import { ProductSubType } from '../../../../../constants';

export const isSplitPayProductSubtype = ( productSubtype: string ) => {
  const splitPay = ProductSubType.SplitPay

  return productSubtype === splitPay
};
